import React, { useRef } from "react";
import SignatureCanvas from "react-signature-canvas";
import Modal from "react-modal";
import PropTypes from "prop-types";

Modal.setAppElement("#app");

const HsqSignaturePad = ({ onSave, disabled, error, value }) => {
  const signCanvasRef = useRef({});
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [selectedImage, setSelectedImage] = React.useState("");

  // Keep internal state in sync with prop (e.g. when form loads saved data)
  React.useEffect(() => {
    if (value !== selectedImage) {
      setSelectedImage(value || "");
    }
  }, [value]);

  function openModal() {
    if (!disabled) setIsOpen(true);
  }

  function afterOpenModal() {
    // Load existing signature onto the canvas when modal opens
    if (
      selectedImage &&
      signCanvasRef.current &&
      typeof signCanvasRef.current.fromDataURL === "function"
    ) {
      signCanvasRef.current.fromDataURL(selectedImage);
    }
  }

  function closeModal() {
    setIsOpen(false);
  }

  // Call onSave whenever selectedImage changes (mirrors job application pattern)
  React.useEffect(() => {
    if (selectedImage && onSave) {
      onSave(selectedImage);
    }
  }, [selectedImage]);

  const handleOnSubmit = () => {
    setSelectedImage(
      signCanvasRef.current.getTrimmedCanvas().toDataURL("image/png"),
    );
    closeModal();
  };

  const clearCanvas = () => {
    signCanvasRef.current.clear();
  };

  return (
    <React.Fragment>
      <div
        className={`signatureWrap ${error ? "signatureWrapError" : ""}`}
        onClick={() => (disabled ? {} : openModal())}
      >
        <img src={selectedImage} alt="" />
        {!selectedImage && <p className="label">Sign here</p>}
      </div>
      {!disabled && selectedImage && (
        <div style={{ marginBottom: 16 }}>
          <button
            type="button"
            className="primary signature-clear-btn"
            onClick={() => {
              setSelectedImage("");
              onSave("");
            }}
          >
            Clear
          </button>
        </div>
      )}

      <Modal
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        className="HsqSignatureModal"
        overlayClassName="HsqSignatureModal-overlay"
        contentLabel="Draw your signature"
      >
        <section>
          <div className="modal-header">
            <p className="sign_close">Draw your signature.</p>
            <div className="close-btn" onClick={() => closeModal()}>
              <span>&times;</span>
            </div>
          </div>
          <SignatureCanvas
            ref={signCanvasRef}
            canvasProps={{ width: 760, height: 215 }}
          />
          <p className="sign_buttons">
            <button
              type="button"
              className="primary"
              onClick={() => clearCanvas()}
            >
              Clear
            </button>
            <button
              type="button"
              className="primary"
              onClick={() => handleOnSubmit()}
            >
              Confirm
            </button>
          </p>
        </section>
      </Modal>
    </React.Fragment>
  );
};

HsqSignaturePad.propTypes = {
  onSave: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  value: PropTypes.string,
};

export { HsqSignaturePad };
